import { gsap } from '@theme/gsap';
import { ScrollTrigger } from '@theme/ScrollTrigger';
import Lenis from '@theme/lenis';

gsap.registerPlugin(ScrollTrigger);

let lenis;

function initLenis() {
  if (lenis) return;
    lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      smoothTouch: false,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
}

function splitWords(el) {
  const text = el.textContent.trim();
  el.innerHTML = '';
  text.split(' ').forEach((word, i, arr) => {
    const span = document.createElement('span');
    span.textContent = word;
    span.style.display = 'inline-block';
    span.style.setProperty('--i', i + 1);
    el.appendChild(span);
    if (i < arr.length - 1) el.appendChild(document.createTextNode(' '));
  });
  el.dataset.split = 'true';
}

function assignGridIndexes(section) {
  section.querySelectorAll('.animation-grid-item').forEach((item, i) => {
    item.style.setProperty('--i', i + 1);
  });
}

function initAnimations() {
  // Kill all existing ScrollTriggers
  ScrollTrigger.getAll().forEach(t => t.kill());

  // Reset all animated sections before reinitializing
  document.querySelectorAll('[data-animate]').forEach(section => {
    section.classList.remove('inview');
  });

  document.querySelectorAll('[data-animate]').forEach(section => {
    // Handle text animation
    if (section.classList.contains('animation-text')) {
      const textEls = section.querySelectorAll('h1,h2,h3,h4,h5,h6,p');

      if (textEls.length > 0) {
        textEls.forEach(el => {
          if (el.dataset.split !== 'true') splitWords(el);
        });
      } else if (section.textContent.trim() !== '' && section.dataset.split !== 'true') {
        splitWords(section);
      }
    }

    // Handle grid animation
    if (section.classList.contains('animation-grid')) {
      assignGridIndexes(section);
    }

    // Handle block animation
    if (section.classList.contains('animation-block')) {
      section.style.setProperty('--i', 1);
    }

    // Create ScrollTrigger
    ScrollTrigger.create({
      trigger: section,
      start: 'top 95%',
      end: 'bottom 0%',
      onEnter: () => section.classList.add('inview'),
      onEnterBack: () => section.classList.add('inview'),
      onLeave: () => section.classList.remove('inview'),
      onLeaveBack: () => section.classList.remove('inview'),
    });
  });

  ScrollTrigger.refresh();
}

function initParallax() {
  gsap.utils.toArray('[data-speed]').forEach(el => {
    const speed = parseFloat(el.dataset.speed);
    gsap.to(el, {
      yPercent: () => (1 - speed) * 100,
      ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', scrub: true },
    });
  });
}

function boot() {
  initLenis();
  initAnimations();
  initParallax();
}

if (document.readyState !== 'loading') boot();
else document.addEventListener('DOMContentLoaded', boot);

window.addEventListener('page-transition:done', () => {
  setTimeout(() => {
    ScrollTrigger.getAll().forEach(t => t.kill());
    initAnimations();
    initParallax();
    ScrollTrigger.refresh();
  }, 100);
});

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      ScrollTrigger.getAll().forEach(t => t.kill());
      initAnimations();
      initParallax();
    }, 300);
  });

  document.addEventListener('shopify:section:unload', () => {
    ScrollTrigger.getAll().forEach(t => t.kill());
  });

  document.addEventListener('shopify:block:select', e => {
    if (e.target?.dataset?.animate) e.target.classList.add('inview');
  });

  document.addEventListener('shopify:block:deselect', e => {
    if (e.target?.dataset?.animate) e.target.classList.remove('inview');
  });
}
